import {
  Component,
  computed,
  effect,
  inject,
  signal,
  untracked,
} from "@angular/core";
import { NZ_MODAL_DATA, NzModalRef } from "ng-zorro-antd/modal";
import { NzTagComponent } from "ng-zorro-antd/tag";
import { NzIconModule } from "ng-zorro-antd/icon";
import { FormatBytesPipe } from "../../../shared/pipes/format-bytes.pipe";
import { NzListModule } from "ng-zorro-antd/list";

// max number of files listed. Confirmation is for judgement, not indepente audit
const MAX_LISTED = 30;

@Component({
  selector: "app-restore-confirm",
  imports: [NzTagComponent, NzIconModule, FormatBytesPipe, NzListModule],
  templateUrl: "./restore-confirm.component.html",
  styleUrl: "./restore-confirm.component.less",
})
export class RestoreConfirmComponent {
  readonly modalRef = inject(NzModalRef);
  readonly modalData = inject<{ bucket: string; nodes: [] }>(NZ_MODAL_DATA);

  protected bucket = signal<string | undefined>(this.modalData.bucket);
  protected nodes = signal<any[]>(this.modalData.nodes);

  // could have done these with computed, but did in inside an effect in constructor to populate 4 things in 1 pass.
  protected eligibleBytes = signal<number>(0);
  protected skippedFiles = signal<any[]>([]);
  public folders = signal<any[]>([]);
  public eligibleFiles = signal<any[]>([]);

  protected readonly maxListed = MAX_LISTED;
  protected acknowledged = signal<boolean>(false);

  /** ng-zorro status presets, not palette presets or hex: they render the soft tinted
   *  tag and follow the theme, where a hex value forces the loud filled variant. */
  protected classColor: Record<string, string> = {
    STANDARD: "success",
    GLACIER_IR: "processing",
    DEEP_ARCHIVE: "default",
  };
  protected classLabel: Record<string, string> = {
    STANDARD: "Standard",
    GLACIER_IR: "Glacier IR",
    DEEP_ARCHIVE: "Deep Archive",
  };

  constructor() {
    effect(() => {
      var size = 0;
      var eligibleFiles: any[] = [];
      var folders: any[] = [];
      var skippedFiles: any[] = [];

      this.nodes().forEach((node) => {
        if (node.type == "file") {
          if (node.storage_class == "DEEP_ARCHIVE") {
            eligibleFiles.push(node);
            size += node.size;
          } else {
            skippedFiles.push(node);
          }
        } else {
          folders.push(node);
        }
      });

      untracked(() => {
        this.eligibleBytes.set(size);
        this.skippedFiles.set(skippedFiles);
        this.eligibleFiles.set(eligibleFiles);
        this.folders.set(folders);
      });
    });
  }
}
